import PropTypes from 'prop-types';
export const SelectPropTypes = {
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    onChanged: PropTypes.func,
    hint: PropTypes.string,
    optional: PropTypes.string,
    children: PropTypes.node,
    label: PropTypes.string,
    val: PropTypes.string,
    icon: PropTypes.string,
    width: PropTypes.string,
    isInvalid: PropTypes.bool,
    noLabel: PropTypes.bool,
    hideIcon: PropTypes.bool
};
export const SelectDefaultValues = {
    placeholder: '',
    label: '',
    disabled: false,
    optional: '',
    hint: '',
    isInvalid: false
};
//# sourceMappingURL=select-V2.prop-types.js.map